export default __webpack_public_path__ + "static/media/hyperspace-no-1.cbf2fe79.ogg";